export default __webpack_public_path__ + "static/media/spoolSheets3.f80557d4.jpg";